import React from 'react';
import { Pie } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Title, Tooltip, Legend } from 'chart.js';

ChartJS.register(ArcElement, Title, Tooltip, Legend);

const PieChartComponent = ({ data }) => {
  const chartData = {
    labels: data.labels,
    datasets: [
      {
        data: data.values,
        backgroundColor: data.colors,
        borderColor: 'white',
        borderWidth: 1,
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      title: {
        display: !!data.title, // Only show title if provided
        text: data.title || '', // Dynamic title text
        font: {
          size: 20,
          weight: 'bold',
          family: 'Arial',
        },
        color: '#333',
        padding: { top: 20, bottom: 10 },
        align: 'center',
      },
      tooltip: {
        callbacks: {
          label: (tooltipItem) => `${tooltipItem.label}: ${tooltipItem.raw}`,
        },
      },
    },
    hover: {
      mode: 'nearest',
      intersect: true,
      animationDuration: 400,
    },
    elements: {
      arc: {
        hoverOffset: 10,
      },
    },
  };

  return (
    <div className="PieChartComponent">
      <Pie data={chartData} options={options} />
    </div>
  );
};

export default PieChartComponent;
